import { AXIOS_INSTANCE } from './mutator/customAxiosInstance';

/**
 * Utilities for interacting with the Axios instance
 * This axios instance is used by the React Query client generated by Orval
 */

/**
 * Get the current axios instance used by Orval generated React Query client
 * @returns AxiosInstance
 */
export const getAxiosInstance = () => AXIOS_INSTANCE;

/**
 * Sets the access token as a Bearer token in the Authorization header of the axios instance
 * If the token is not defined, the Authorization header is cleared
 * @returns void
 */
export const setAxiosAuthToken = (token?: string) => {
  if (token) {
    getAxiosInstance().defaults.headers['Authorization'] = `Bearer ${token}`;
  } else {
    delete getAxiosInstance().defaults.headers['Authorization'];
  }
};

/**
 * Returns the access token from the Authorization header without the Bearer prefix
 * @returns string | undefined based on if the access token is defined
 */
export const getAxiosAuthToken = () => {
  const header = getAxiosInstance().defaults.headers['Authorization'];

  if (header && typeof header === 'string') {
    const [_, token] = header.split(' ')[1];
    return token;
  }

  return undefined;
};
